import { ActivatedRoute, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpRequest } from '@angular/common/http';
import { StorageService } from '../storage/storage.service';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { AuthMode } from 'src/app/@shared/enum/AuthMode';
import { detectar_mobile } from 'src/app/@shared/helpers/vesta-helpers';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

export class User {
  auth_Token: string;
  id: string;
  company_id: number;
  is_admin: boolean;
  company_logo: string;
  company_name: string;
  company_rule: boolean;
}

export class UserInput {
  username?: string;
  password?: string;
}

export interface InfoFuncionalidade {
  funcionalidadeNomeCompleto: string;
  funcionalidadeNome: string;
  sessao: string;
  campo: string;
  descricao: string;
}

@Injectable({
  providedIn: 'root'
})

export class AuthService {

  auth: AuthMode;
  authUrl: string;
  authExternalUrl: string;
  constructor(
    private http: HttpClient,
    private router: Router,
    private activatedRoute: ActivatedRoute
  ) {
    
   this.auth = AuthMode.Bearer;
   //this.auth = !environment.production || detectar_mobile() ? AuthMode.Bearer : AuthMode.Cookie; 
   //implantação 2fa foi verifica que trecho acima estava causando erro de login. R.Azuma 


    this.authUrl = this.auth == AuthMode.Bearer ?
      '.auth/bearer' :
      '.auth/cookie';
    this.authExternalUrl = this.authUrl + "External";
  }

  getFeatureIdByRoute(route?: ActivatedRoute) : string {
    var feature = route?.data['_value']['FEATURE_ID'];
    if (!feature && route?.firstChild) return this.getFeatureIdByRoute(route?.firstChild);
    else return feature;
  }

  getAuthRequest(intercepted: HttpRequest<any>, baseUrl: string): HttpRequest<any> {
    var featureId = this.getFeatureIdByRoute(this.activatedRoute.root?.firstChild?.firstChild);
    const mod = StorageService.getItemLocalStorage(featureId);
    return this.auth == AuthMode.Bearer ?
      this.getAuthRequestBearer(intercepted, mod, baseUrl) :
      this.getAuthRequestCookie(intercepted, mod, baseUrl);
  }

  desconsiderar: string[] = [
    ".auth"
  ];
  getAuthRequestCookie(intercepted: HttpRequest<any>, mod: any, baseUrl: string): HttpRequest<any> {

    let headers = intercepted.headers;//.set('Set-Cookie', "HttpOnly;SameSite=None;");
    if (mod && this.desconsiderar.filter(d => intercepted.url.startsWith(d)).length == 0)
      headers = headers.set('Data-Source', mod);

    return intercepted.clone({
      url: `${baseUrl}${intercepted.url}`,
      headers,
      withCredentials: true,
      responseType: 'json'
    });
  }

  getAuthRequestBearer(intercepted: HttpRequest<any>, mod: any, baseUrl: string): HttpRequest<any> {

    const token = this.authUrl != intercepted.url ? StorageService.getToken() : null;

    let headers = intercepted.headers.set('Authorization', 'Bearer ' + token || '');
    if (mod && this.desconsiderar.filter(d => intercepted.url.startsWith(d)).length == 0)
      headers = headers.set('Data-Source', mod);

    return intercepted.clone({
      url: `${baseUrl}${intercepted.url}`,
      headers,
      withCredentials: false,
      responseType: 'json'
    });
  }

  authenticate(credentials: any): Observable<any> {
    return this.http.post(this.authUrl, credentials, httpOptions);
  }

  checkFeature(nomeModulo: string, GerarLog: boolean = false): Observable<boolean | UrlTree> {
    return this.http.get<boolean>(`.auth/checkFeature/${nomeModulo}?GerarLog=${GerarLog}`, httpOptions)
      .pipe(
        map(response => {
          StorageService.setItemLocalStorage(nomeModulo, response['moduloBaseOrigemId']);
          return response['permitido']
            ? response['permitido']
            : this.router.createUrlTree(['unauthorized']/*, { skipLocationChange: true }*/)
        })
      );
  }

  setState({ perfilacessotipo, descricao, filialid, nome, email, username, auth_token, agenteid, codIata }) {
    const salt = btoa('sequoia');

    localStorage.setItem(btoa('tipo'), `${btoa(this.removeInvalideCharacters(perfilacessotipo))}${salt}`);
    localStorage.setItem(btoa('descricao'), `${btoa(this.removeInvalideCharacters(descricao))}${salt}`);
    localStorage.setItem(btoa('filialid'), `${btoa(this.removeInvalideCharacters(filialid))}${salt}`);
    localStorage.setItem(btoa('nome'), `${btoa(this.removeInvalideCharacters(nome))}${salt}`);
    localStorage.setItem(btoa('email'), `${btoa(this.removeInvalideCharacters(email))}${salt}`);
    localStorage.setItem(btoa('username'), `${btoa(this.removeInvalideCharacters(username))}${salt}`);
    localStorage.setItem(btoa('auth_token'), `${btoa(this.removeInvalideCharacters(auth_token))}${salt}`);
    localStorage.setItem(btoa('agenteid'), `${btoa(this.removeInvalideCharacters(agenteid))}${salt}`);
    localStorage.setItem(btoa('codIata'), `${btoa(this.removeInvalideCharacters(codIata))}${salt}`);

    this.funcionalidadeAjuda().subscribe((response: InfoFuncionalidade[]) => {
      localStorage.setItem(btoa('funcionalidadesajuda'), `${btoa(JSON.stringify(response))}${salt}`);
    });
  }

  alterarDados(obj: any) {
    return this.http.post('.auth/updateInfoUser', obj, httpOptions) as Observable<any>;
  }

  atualizarDados(credentials: any): Observable<any> {
    return this.http.post('.auth/updateInfoUser', credentials, httpOptions);
  }

  atualizarSenha(credentials: any): Observable<any> {
    return this.http.post('.auth/updatePassword', credentials, httpOptions);
  }

  forgotPassword(userName: any): Observable<any> {
    return this.http.post(`.auth/ForgotPasswordToken/${userName}`, httpOptions);
  }

  twoFactorCode(userName: any): Observable<any> {
    return this.http.post(`.auth/TwoFactorCode/${userName}`, httpOptions);
  }

  bloquearPassword(userName: any): Observable<any> {
    return this.http.post(`.auth/BloquearSenhaUser/${userName}`, httpOptions);
  }

  updateAcessAttemp(input): Observable<any> {
    return this.http.post('.auth/UpdateAccessAttempt', input, httpOptions);
  }

  checkAuthenticationCode(secretCode: any, userName: any ): Observable<any> {
    return this.http.get(`.auth/ValidateTokenPassword/${secretCode}/${userName}`, httpOptions);
  }

  checkAuthenticationCode2fa(secretCode: any, userName: any ): Observable<any> {
    return this.http.get(`.auth/ValidateTokenPassword2fa/${secretCode}/${userName}`, httpOptions);
  }

  logout(): Observable<any> {
    localStorage.clear();
    sessionStorage.clear();
    return this.http.post(`.auth/logoff`, httpOptions) as Observable<any>;
  }

  checkUserHasFeature(obj: any): Observable<any> {
    return this.http.post(`.auth/checkUserHasFeature`, obj, httpOptions) as Observable<any>;
  }

  acessoExterno(hash: string): Observable<any> {
    return this.http.post(this.authExternalUrl, { hash }, httpOptions);
  }

  funcionalidadeAjuda(): Observable<InfoFuncionalidade[]> {
    return this.http.get<InfoFuncionalidade[]>(`FuncionalidadeAjuda`, httpOptions);
  }

  removeInvalideCharacters(value) {
    try {

      return value.replace("–", " ");
    } catch (e) {
      return value;
    }
  }
}
